// src/page/PanelComercioWrapper.jsx
import { useState } from "react";
import LoginComercio from "./LoginComercio";
import PanelComercio from "./PanelComercio";

export default function PanelComercioWrapper() {
  const [comercioUser, setComercioUser] = useState(null);

  // Si no hay usuario → mostramos el login de comercio
  if (!comercioUser) {
    return <LoginComercio setComercioUser={setComercioUser} />;
  }

  // Si hay usuario → mostramos el panel de comercio
  return <PanelComercio comercioUser={comercioUser} />;
}
